import { createContext, type RefObject, useContext } from "react";
import { MenuItem } from "./types";

export type MenuContextValue = {
  onSelect: (optionId: string) => void;
  options: MenuItem[];
  rtl?: boolean;
  rootTriggerRef?: RefObject<HTMLElement | null>;
  portal?: boolean | HTMLElement | RefObject<HTMLElement | null>;
};

export const MenuContext = createContext<MenuContextValue>(
  {} as MenuContextValue,
);

export const useMenuContext = () => {
  return useContext(MenuContext);
};
